<template>
    <div :class="appClass" @click="clickOff">
      <header class="header">
        
        <h1 class="logo"><img class="logo__image" src="brand/rose-logo.png" alt="Rose &amp; Associates Logo"><span class="logo__text">Rose &amp; Associates</span></h1><!--
     --><div :key="this.report" class="current-client">
          <div :class="setClientContainerClass()">
            <span class="current-client__label">{{ _translate('toolbar.currentClient') }}</span>
            <span class="current-client__val">{{ getClientName() }}</span>
          </div>
          <div :class="setClientContainerClass()">
            <span class="current-client__label">{{ _translate('toolbar.currentView') }}</span>
            <span class="current-client__val">{{ getCurrentView() }}</span>
            <button class="current-client__link" @click="setView('snapshots')">(change)</button>
          </div>
        </div><!--
     --><ul class="toolbar">
          
          <li class="toolbar__item">
            <button :class="setToolButtonClass('client')" @click="setView('client')">
              <Icon icon="client"></Icon>
              <span class="toolbar__item-tip">{{ _translate('toolbar.clientPanelButton') }}</span>
            </button>
          </li><!--
       --><li class="toolbar__item">
            <button :class="setToolButtonClass('load')" @click="startAction('load')">
              <Icon icon="load"></Icon>
              <span class="toolbar__item-tip">{{ _translate('toolbar.clientLoadButton') }}</span>
            </button><!--
       --><li class="toolbar__item">
            <button :class="setToolButtonClass('print')" @click="openPrint('print')">
              <Icon icon="print"></Icon>
              <span class="toolbar__item-tip">{{ _translate('toolbar.printButton') }}</span>
            </button>
          </li><!--
       --><li class="toolbar__item">
            <button :class="setToolButtonClass('tools')" @click="setView('tools')">
              <Icon icon="tools"></Icon>
              <span class="toolbar__item-tip">{{ _translate('toolbar.toolsButton') }}</span>
            </button>
          </li><!--
       --><li class="toolbar__item">
            <button :class="setToolButtonClass('settings')" @click="setView('settings')">
              <Icon icon="settings"></Icon>
              <span class="toolbar__item-tip">{{ _translate('toolbar.settingsButton') }}</span>
            </button>
          </li><!--
       --><li class="toolbar__item">
            <button :class="setToolButtonClass('logout')" @click="logout()">
              <Icon icon="logout"></Icon>
              <span class="toolbar__item-tip">{{ _translate('toolbar.logoutButton') }}</span>
            </button>
          </li>          

        </ul>

      </header>

      <div :key="this.key" class="app__canvas">

        <div class="report-background" :style="setBackground"></div>

        <Panel v-if="hasClient()" context="client" tabs="client" align="left" sub="true" width="2" subwidth="1" save="saveClient"></Panel>
        <Panel context="load" align="left" width="2"></Panel>
        <Panel context="tools" align="right" sub="true" width="4" subwidth="x3" controller="tools"></Panel>
        <Panel context="settings" tabs="settings" sub="true" align="right" width="3" subwidth="x2" save="saveConstants"></Panel>
        <Panel v-on:updateApp="updateApp" context="snapshots" sub="true" align="left" width="4" subwidth="x3" save="saveSnapshots"></Panel>

        <div :key="this.report" id="app-reports" :class="setReportsClass">

          <ul v-if="hasClient()" class="report-tabs">
            <li :class="setReportTabClass('networth')"><button class="report-tabs__button" @click="setActiveReport('networth', true)">{{ _translate('report.netWorth') }}</button></li><!--
         --><li :class="setReportTabClass('retirementplanner')"><button class="report-tabs__button" @click="setActiveReport('retirementplanner', true)">{{ _translate('report.retirementPlanner') }}</button></li><!--
          --><li :class="setReportTabClass('financialgps')"><button class="report-tabs__button" @click="setActiveReport('financialgps', true)">{{ _translate('report.financialGPS') }}</button></li><!--         
        --><li v-if="isDevMode()" :class="setReportTabClass('test')"><button class="report-tabs__button" @click="setActiveReport('test', true)">Dev</button></li>                        
          </ul>

          <div id="app-reports-wrap" class="app__report-wrap">

            <div v-if="this.$data.report === 'start'" class="start-block">

              <h2>{{ _translate('welcome.introQuestion') }}</h2>

              <div class="start-block__actions">

                <div class="start-block__action">
                  <div class="start-block__action-inner">
                    <div class="start-block__action-button">
                      <button @click="startAction('new')">
                        <Icon icon="add"></Icon>
                        {{ _translate('welcome.add') }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="start-block__action">
                  <div class="start-block__action-inner">
                    <div class="start-block__action-button">
                      <button @click="startAction('load')">
                        <Icon icon="load"></Icon>
                        {{ _translate('welcome.load') }}
                      </button>
                    </div>
                  </div>
                </div>

              </div>

            </div>
            
            <div v-if="hasClient()">
              <div :class="setReportClass('networth', true)">
                <NetWorth></NetWorth>
              </div>
              <div :class="setReportClass('retirementplanner', true)">
                <RetirementPlanner></RetirementPlanner>
              </div>
              <div :class="setReportClass('financialgps', true)">
                <FinancialGPS></FinancialGPS>
              </div>            
          	  <div v-if="isDevMode() && hasClient()" :class="setReportClass('test')">
                <Developer></Developer>
              </div>
            </div>

          </div>

          <a :class="setBacktoTopClass()" href="#" @click="scrollToTop()"><Icon icon="chevron-down"></Icon></a>

        </div>

      </div>

      <Modal></Modal>

      <div :class="getErrorClass()">
        <p><span v-html="getErrorMessage()"></span></p>
      </div>

      <div class="app-loading" :style="{ 'background-image': 'url(\'img/loading.svg\')' }">{{ _translate('working.text') }}&hellip;</div>
      <canvas id="ctx"></canvas>
    </div>
</template>

<script>

// import TextInput from './TextInput.vue'
import Panel from './Panel.vue'
import Icon from './Icon.vue'
import NetWorth from './NetWorth/NetWorth.vue'
import RetirementPlanner from './RetirementPlanner/RetirementPlanner.vue'
import FinancialGPS from './FinancialGPS/FinancialGPS.vue'
import Developer from './Developer/Developer.vue'
import Modal from './Modal.vue'



export default {

  components: {
    // TextInput,
    Panel,
    Icon,
    NetWorth,
    RetirementPlanner,
    FinancialGPS,
    Developer,
    Modal,
  },

  computed: {

    setReportsClass() {

      var c = 'app_report';

      switch (this.$data.view) {

        case 'client': 
          c += ' left-50';
          break;

        case 'load': 
          c += ' left-50';
          break;

        case 'tools':
          c += ' right-25';
          break;

        case 'settings':
          c += ' right-33';
          break;

        case 'snapshots':
          c += ' left-25';
          break;          

        }

      return c;

    },

    setBackground() {

      var i = "background-image: url(\'img/" + this.$data.report + ".jpg\')";
      return i;

    },

    appClass() {

      var c = 'app';

      if ( this.$data.working ) {

        c += ' js-working';

      }

      return c;

    }

  },

  methods: {

    isDevMode() {

      return this.$store.getters.getDevMode();

    },

    updateApp() {

      this.$data.key += 1;

    },

    hasClient() {

      var client = this.$store.getters.getClientObject;

      if ( client !== false ) {

        if ( client.id !== undefined) {

          return true;

        }

      }

      return false;

    },

    getClientName() {

      var name = this.$store.getters.getCurrentClientName()
      return name;

    },

    startAction(action) {

      var self = this;

      if ( action === 'new' ) {

        this.$store.dispatch('newClient');

        setTimeout(function(){

          self.$data.view = 'client';
          self.$data.report = 'networth';

          self.$store.dispatch('openModal', 'disclaimers');

        }, 5);

      }

      else if ( action === 'load' ) {

        this.$data.view = 'load';
        this.$data.report = 'networth';

      }

    },

    setView(view) {

      /**
       * Closing Tools
       *
       * @since  1.2.5
       * 
       * This block fires when closing the tools panel via the toolbar.
       * The idea here is to set temporary value on the state, which 
       * indicates that the sub panel of the tools panel needs to be 
       * closed. When the data change triggers an update of the view,
       * we'll check for this controller, and take the appropriate action.
       */

      var act = true;

      if ( this.$data.view !== 'base' ) {

        this.$store.dispatch('setController', {
          area: 'tools',
          prop: 'forceClose',
          val:  true,
        });

      }

      if ( this.getCurrentDataSet() && view === 'client') {

        act = confirm(this._translate('warning.editGPSData'));

      }

      if ( act ) {
        this.$data.view = (this.$data.view === view) ? 'base' : view;
      }

    },

    openPrint(view) {

      this.$store.dispatch('openModal', 'printForm');

    },

    clickOff(e) {

      window._clickOff(this.$children);

    },

    setClientContainerClass() {

      var c = 'current-client__line',
          client = this.$store.getters.getClientObject;

      if ( client === false ) {
        c += ' js-hidden';
      }

      return c

    },

    setToolButtonClass(view) {

      var c = 'toolbar__button',
          modalState      = this.$store.getters.modalState,
          modalComponent  = this.$store.getters.modalComponent,
          client = this.$store.getters.getClientObject;

      switch ( view ) {

        case 'client':

          if ( client === false ) {

            c += ' js-hidden';
            return c;

          }
          break;

        case 'print':

          var tool = this.$store.getters.getCurrentTool;
          if ( this.$data.report === 'start' && tool === false ) {

            c += ' js-hidden';
            return c;

          }
          break;

      }

      if ( modalState === true && modalComponent === 'printForm' && view === 'print' ) {

        c += ' js-active';

      }

      else if ( view === this.$data.view && modalState !== true ) {

        c += ' js-active';

      }

      return c;

    },

    setReportClass(report) {

      var c = 'report';

      if ( report === this.$data.report ) {

        c += ' js-active';

      } 

      return c;
      
    },

    setBacktoTopClass() {

      var c = 'scroll-top';

      if ( this.$data.reportScrolled ) {

        c += ' js-show';

      }

      return c;

    },

    scrollToTop() {

      function doScroll() {

        reports.scrollTop -= int;

        if ( reports.scrollTop > 1 ) {

          setTimeout(function(){

            doScroll();

          }, 10);

        }

        else { 

          reports.scrollTop = 0;

        }

      }

      var reports = document.getElementById('app-reports'),
          start   = reports.scrollTop,

          int = start / 30;
          doScroll();

    },

    setReportTabClass(report) {

      var c = 'report-tabs__item';

      if ( report === this.$data.report ) {

        c += ' js-active';

      } 

      return c;
      
    },

    setActiveReport(report, close = false) {

      this.$store.dispatch('setCurrentReport', report);
      this.$data.report = report;
      if ( close ) { this.$data.view = 'base' }

    }, 

    getCurrentView() {

      var snapshot = this.$store.getters.getCurrentSnapshot,
          val = 'Current';

      if ( snapshot !== 'current' ) {

        var date = new Date(snapshot.substr(0,4) + '/' + snapshot.substr(4,2) + '/' + snapshot.substr(6)); 
        val = date.toCustomString();

      }

      return val;

    },

    getCurrentDataSet() {

      var snapshot = this.$store.getters.getCurrentSnapshot,
          gps = this.$store.getters.getFieldData({field: 'snapshots.gps'});

      return ( gps === snapshot && snapshot !== 'current' )

    },

    workingTimeout() {

      var self = this;

      this.$data.workingDelay = setTimeout(function(){

        self.$data.working = false;
        self.$data.workingDelay = false;

      }, 700);

    },

    logout() {

      window.location = window.api_uri + 'index.php?logout';

    },

    hasError() {

      var errors = this.$store.getters.errorState,
          status = false;

      for ( var k in errors ) {

        if (errors[k]) {

          status = true;
          this.$data.errorMsg = this.$data.errorMsgs[k];

        }

      }

      if ( ! status ) {

        this.$data.errorMsg = '';

      }

      return status;

    },

    getErrorClass() {

      var c = 'app-error';

      if ( this.hasError() ) {

        c += ' js-active';

      }

      return c;

    },

    getErrorMessage() {

      return this.$data.errorMsg;

    }

  },

  mounted: function() {

    var self = this;

    document.getElementById('app-reports').addEventListener('scroll', function(){

      if ( this.scrollTop > 250 ) {

        self.$data.reportScrolled = true;

      }

      else {

        self.$data.reportScrolled = false;

      }

    });

  },

  data: function() {

    return {

      key: 0,
      view: 'start',
      report: 'start',
      reportScrolled: false,
      working: false,
      workingDelay: false,
      errorMsg: '',
      errorMsgs: {
        '302': 'Date Conflict: The plan start date cannot be set to after retirement',
      },

    }

  }

}

</script>

<style lang="scss">

	@import '../assets/sass/framework/vendor/_normalize.scss';
	@import '../assets/sass/framework/vendor/_boilerplate.scss';


  body {

		font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;

  }

  .app {

    overflow: hidden;

  }

  .app-loading {

    position: fixed;
    bottom: 0;
    left: 0;

    background-position: 1.25rem .65rem;
    background-repeat: no-repeat;

    z-index: 1000;

    font-size: .65rem;
    color: #7f7f7f;

    padding: 2.35rem .55rem .5rem;

    background-color: #3b4956;

    opacity: 0;
    visibility: hidden;
    transition: opacity .3s ease, visibility .3s ease;

  }

  .js-working {

    .app-loading {

      opacity: 1;
      visibility: visible;

    }
  }

  .app-error {

    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: #d31323;
    color: #fff;
    font-size: .8rem;
    padding: 1em 3em;

    z-index: 10;

    opacity: 0;
    visibility: hidden;

    transition: opacity .3s ease, visibility .3s ease;

    &.js-active {

      opacity: 1;
      visibility: visible;

    }

  }

  .header {

    background: #eee;
    height: 5rem;
    position: relative;
    z-index: 100;

    border-bottom: 1px solid #ddd;
    display: flex;

  }

  .current-client {

    flex: 1;
    font-size: .75rem;
    padding: 1.35rem 1rem 1rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    letter-spacing: .05em;
    color: #727272;

  }

  .current-client__line {

    visibility: visible;
    opacity: 1;
    transition: .3s visibility ease, .3s opacity ease;

    &.js-hidden {
      visibility: hidden;
      opacity: 0;
    }

  }

  .current-client__val {

    font-weight: 600;
    color: #103c63;

  }

  .current-client__link {

    appearance: none;
    border: 0;
    background: none;
    padding: 0;
    letter-spacing: .05em;

  }

  .logo {

    // background-image: 'url('brand/rose-logo.png')';
    background-position: center;
    background-repeat: no-repeat;
    background-size: 198px 50px;

    margin: 15px;
    height: 50px;
    width: 198px;

    display: inline-block;
    vertical-align: top;

  }

  .logo__image {

    max-width: 100%;
    height: auto;
    
  }

  .logo__text {
  
    display: block;
    visibility: none;
    opacity: 0;
    overflow: hidden;
    width: 0;
    height: 0;

  } 


  /**
   * TOOL BAR STYLES 
   */
  
  .toolbar {

    height: 3.125rem;
    // width: calc(100% - 228px);

    display: inline-flex;
    justify-content: flex-end;
    vertical-align: top;

    padding: 0;
    list-style-type: none;
    text-align: right;

  }

  .toolbar__item {

    display: inline-block;
    position: relative;

    &:first-child {

      .toolbar__button {

        border-width: 0;

      }
      
    }

  }

  .toolbar__button {

    -webkit-appearance: none;
    border: 0;
    border-left: 1px solid #ddd;
    background-color: transparent;
    border-radius: 0;
    padding: 1.625rem;
    outline: none;

    transition: padding .3s linear, width .3s linear;

    overflow: hidden;

    &:hover {

      background-color: #103c63;

      .icon__svg {

        stroke: #fff;

      }

    }

    &:hover {

      .icon {

        transform: scale(1);
        
      }

      .toolbar__item-tip {

        opacity: 1;
        visibility: visible;
        transition-delay: 1s;

      }

    }

    &.js-active {

      background-color: #ddd;

      &:hover {

        background-color: #103c63;

        .icon__svg {

          stroke: #fff;

        }

      }

    }

    &.js-hidden {

      width: 0;
      padding: 1.625rem 0;
      border-color: transparent;

    }

    .icon {

      width: 1.75rem;
      height: 1.75rem;
      transform: scale(.85);
      transition: transform .15s ease;

    }

    .icon__svg {

      stroke: #103c63;

    }

  }

  .toolbar__item-tip {

    background: #fff;
    display: block;
    font-size: .65rem;
    color: #222;
    padding: .5em;

    position: absolute;
    top: 6px;
    left: -10px;
    z-index: 21;

    border-radius: 1px;

    white-space: nowrap;

    opacity: 0;
    visibility: hidden;

    transition: opacity .2s ease, visibility .2s ease;
    transition-delay: .1s;

  }  


  /**
   * APP CANVAS STYLES
   */

  .app__canvas {

    position: relative;
    display: block;
    width: 100%;
    height: calc(100vh - 5rem);

  }

  /**
   * APP START STYLES
   */
  
  .start-block {

    padding-top: 3rem;

    color: #fff;

    h2 {

      text-align: center;

    }

  }
  
  .start-block__actions {

    margin-top: 3rem;
    margin-left: -3rem;
    display: flex;

  }

  .start-block__action {

    width: 50%;
    padding-left: 3rem;

  }

  .start-block__action-inner {

    background: #fff;
    height: 18rem;
    box-shadow: 0 0 5px rgba(0, 0, 0, .1);
    color: #222;

    display: flex;
    flex-wrap: wrap;

    justify-content: center;
    align-items: center;

  } 

  .start-block__action-button {

    width: 100%;
    text-align: center;

    button {

      -webkit-appearance: none;
      background: none;
      border: 0;
      color: #727272;

      font-size: 1.2rem;
      transition: color .2s ease;

      outline: none;

      &:hover,
      &:focus,
      &:active {

        color: #000;

        .icon {

          transform: scale(1);

        }

      }

      &:hover {

        .icon__svg {

          stroke: #f7d46f;

        }

      }

    }

    .icon {

      width: 4rem;
      height: 4rem;
      display: block;
      margin: 0 auto 1.5rem;
      transform: scale(.85);
      transition: transform .2s ease; 

    }

    .icon__svg {

      stroke: #103c63;
      transition: stroke .2s ease;

    }    

  }

  /**
   * APP REPORT STYLES
   */

  .app_report {

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;

    padding: 2.5rem 2.5rem;

    transition: left .7s ease, right .7s ease;

    &.left-50 {

      left: 50%;

    }

    &.left-25 {

      left: 25%;

    }

    &.right-50 {

      right: 50%;

    }

    &.right-33 {

      right: 33%;

    }

    &.right-25 {

      right: 25%;

    }

    h2 {

      font-weight: 400;

    }

  }

  .app__report-wrap {

    max-width: 60rem;
    margin: 0 auto;

  }

  .report-content {

    background: rgba(250, 250, 250, .95);
    padding: 1.5rem 2rem;

  }

  .report-ctrl {

    position: relative;
    
  }

  .report {

    max-height: 0;
    overflow: hidden;
    font-size: .8rem;

    h2 {

      font-size: 3.2em;
      color: white;
      padding: 5rem 2rem 1.6rem;
      text-shadow: 0 0 5px #000;

    }

    h3 {

      font-size: 1.8em;
    }

    h4 {

      font-size: 1.5em;

    }

    &.js-active {

      max-height: none;

    }

  }

  .report__client-info {

    display: none;
    padding: 2rem;
      
  }

  .report__client-name {

    font-size: 1.2em;
    font-weight: bold;
    text-transform: uppercase;

  } 

  .report__disclaimer {

    color: #555;
    font-size: 9px;
    font-style: italic;
    line-height: 1.6em;
    padding: 1rem 0;
    display: none;

  }

  .report-tabs {

    list-style-type: none;
    padding: 0 1.35rem;
    margin: 0 auto 1.5rem;
    max-width: 60rem;

  }

  .report-tabs--chart {

    // margin-bottom: 0;
    margin-top: 1.5em;
    padding-left: 1.15rem;

  }

  .report-tabs__item {

    display: inline-block;

    &:first-child {

      .report-tabs__button {

        border-left: 1px solid #ddd;
        border-radius: 2px 0 0 2px;

      }

    }

    &:last-child {

      .report-tabs__button {

        border-right: 1px solid #ddd;
        border-radius: 0 2px 2px 0;

      }

    } 

    &.js-active {

      .report-tabs__button {

        background-color: rgba(27, 29, 34, .8);
        color: #fff;
        border-color: rgba(27, 29, 34, .9);

      }

    }       

  }

  .report-tabs__button {

    -webkit-appearance: none;
    background: #f4f4f4;
    font-size: .75rem;
    padding: .35rem .65rem;
    border: 1px solid #ddd;
    border-left: 0;
    outline: none;
    border-radius: 0;

  }

  .report-background {

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 22rem;

    background-position: bottom center;
    background-size: cover;
    background-repeat: no-repeat;

  }

  .report__section {

    border: 1px solid #eee;
    margin: 1rem 0;
    border-radius: 2px;
    background: #fff;

    h3 {

      background: #e2e2e2;
      padding: 1rem;
      border-radius: 2px 2px 0 0;
      position: relative;
      font-size: 1.25rem;

    }

    .checkbox-wrap {

      margin-bottom: 0;
      padding: 0;
      transform: translate3d(0, .35rem, 0);

    }

    .checkbox__input {

      width: 1rem;
      height: 1rem;
      box-shadow: none;
      margin-right: .75rem;

      &::after {

        background: #06a0df;
        top: 3px;
        left: 3px;
        right: 3px;
        bottom: 3px;
        border-radius: 1px;

      }      

    }

  }

  .report__info {

    padding: 1rem;
    margin-top: 1.5rem;
    font-size: 1rem;
    line-height: 1.8em;
    color: #5a5a5a;
    max-width: 50rem;

    & + & {

      margin-top: 0;
      padding-top: 0;

    }

  }

  .report__info--large {

    font-size: 1.2rem;
    
  }

  .report__info-highlight {

    color: #06a0df;

  }

  .report__list {

    list-style-type: none;
    padding: 0;

    &:last-child {

      .report__list-item {

        &:last-child {

          border: 0;

        }

      }

    }    

  }

  .report__section-heading,
  .report__list-item {

    padding: 1rem;
    display: flex;

    span {

      flex-grow: 1;

    }

    .report__variable {

      margin-left: .25em;
      color: #06a0df;

    }

    .report__value {

      width: 200px;
      flex-grow: 0;
      text-align: right;

    }

  }

  .report__value {

      color: #06a0df;

      .negative {

        color: #cb2535;

      }

      &.adjusted {

        color: #fe783d;

      }

  }  

  .report__list-item {

    border-bottom: 1px solid #eee;

  }

  .report__list-label,
  .report__value {

    display: block;

    .text-wrap {

      display: inline;

    }

    .input {

      background: none;
      box-shadow: none;
      color: #06a0df;
      border: 0;
      border-bottom: 1px solid transparent;
      text-align: left;
      width: 3.75em;
      padding-right: 0;
      padding-bottom: .25em;
      padding-left: .25em;
      padding-top: 0;

      &:focus,
      &:active {

        border: 0;
        border-bottom: 1px solid #ddd;

      }

    }

    .input-wrap--percentage,
    .input-wrap--text {

      width: auto;
      display: inline;

      &::after,
      &::before {

        height: 0;
        width: 1em;
        transform: translate3d(0, 1px, 0);

      }

      .input {

        padding-right: 0;

      }

    }

    .input-wrap--text {

      .input {

        padding-left: 0;
        width: 6rem;
        text-align: right;

      } 

    }

    .input--custom-val {

      color: #1aaf54;

    }      

    .reset,
    .apply {

      transform: translate3d(0, .2rem, 0);
      margin-left: .5rem;
      
    }

    .apply {

      margin-left: .75rem;

    }  

  }

  .report__list-edit-label {

    display: inline-block;
    color: #999;
    font-size: .8em;
    transform: translate3d(0.25em, -0.1em, 0);

  }

  .label {

  	font-size: .75rem;
  	display: block;
		margin-bottom: 6px;
		padding: 3px 1px;
    color: #222;
    letter-spacing: .1em;  
    opacity: .8;  

  }

  .reset,
  .apply {

    appearance: none;
    border: 0;
    background: 0;
    outline: none;
    padding: 0;

    .icon {

      width: .85rem;
      height: .85rem;

    }

    &:hover,
    &:focus,
    &:active {

      .icon__svg {

      }

    }

    .icon__svg {

      fill: #777;
      stroke: #777;
      stroke-width: 6px;

    }

    .reset__label {

      display: none;

    }

  }

	.test-state {

		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;

		width: 50%;

		padding: 3rem;

	}

  .scroll-top {

    background: rgba(220, 220, 220, .7);

    width: 2rem;
    height: 2rem;
    display: block;
    padding: .5rem;

    position: fixed;
    bottom: 1rem;
    right: 1rem;

    opacity: 0;
    visibility: hidden;

    transition: opacity .3s ease, visibility .3s ease;

    &.js-show {

      opacity: 1;
      visibility: visible;

    }

    .icon__svg {

      width: .75rem;
      height: .75rem;
      fill: #000;
      stroke: #000;
      stroke-width: 4;
      transform: rotate(180deg) translate3d(0, 1px, 0);

    }
  }

  .note {

    font-size: .75rem;
    font-style: italic;
    letter-spacing: .075em;

  }

  #ctx {

    display: none;
    
  }

</style>



// WEBPACK FOOTER //
// App.vue?5af04db4